export function setReportData (state, data) {
    state.reporte_contacts = data
}
export function setContacts (state, data) {
    state.contacts = data
}
export function setAccounts (state, data) {
    state.accounts = data
}
export function setContactType (state) {

    switch (state.params.type_contact){
        case 'Cliente' :
            state.params_contact = {
                is_customer :1,
                is_provider :0,
                is_employee :0,
            }
            break;
        case 'Proveedor' :
            state.params_contact = {
                is_customer :0,
                is_provider :1,
                is_employee :0,
            }
            break
        case 'Empleado' :
            state.params_contact = {
                is_customer :0,
                is_provider :0,
                is_employee :1,
            }
            break
    }
}

/**
 * Establecer un valor para la variable params.
 */
export function setParams(state, params) {
    state.params = params;
}




// WEBPACK FOOTER //
// ./src/modules/balance-for-contacts/mutations.js